exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-pos{\n  background-color: #FEA100;\n  border-color: #FEA100;\n  color: #fff;\n}\n", ""]);

// exports
